import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './event-selector-item.scss';

@observer
class EventSelectorItem extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
    event: PropTypes.instanceOf(GdsEventModel),
  };

  clearData() {
    const { gdsUiState, event } = this.props;

    gdsUiState.setRsvpFilter('', null);
    gdsUiState.setMealFilter('');
    gdsUiState.setAddressFilter(false);
    gdsUiState.setFilter('');
    gdsUiState.deselectGuests();
    gdsUiState.clearBulkUpdateValues();
    gdsUiState.setSort({
      sortBy: 'guest',
      attribute: null,
      direction: null,
      eventId: event ? event.id : null,
    });
  }

  clickEvent(event) {
    const { analyticsStore, gdsUiState } = this.props;
    let viewName;

    if (event) {
      gdsUiState.setSelectedEvent(event);
      viewName = event.name;
    } else {
      gdsUiState.setAllGuestsView();
      viewName = 'All Events';
    }

    analyticsStore.track('Dashboard Interaction', { action: 'change view', source: 'glm header', view: viewName });
    this.clearData();
  }

  render() {
    const { gdsUiState, event } = this.props;
    let className = styles.eventItem;

    if (!event) {
      if (!gdsUiState.selectedEvent) {
        className = styles.eventItemActive;
      }
      return (
        <li className={className} onClick={() => this.clickEvent(null)}>
          All Events
        </li>
      );
    }
    if (gdsUiState.selectedEvent && gdsUiState.selectedEvent.id === event.id) {
      className = styles.eventItemActive;
    }

    return (
      <li
        className={className}
        onClick={() => this.clickEvent(event)}
        key={event.id}
        data-testid={`select-event-${event.name.toLowerCase().replace(/\s/g, '-')}`}
      >
        {event.name}
      </li>
    );
  }
}

export default EventSelectorItem;
